import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, FormControl, Validators, FormArray } from '@angular/forms';
import { department, interaction, division, user, usermaster } from './../../../models/admin';
import { AdminApiService } from './../../../services/admin.service';
import { UtilityService } from './../../../services/utility.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { element } from 'protractor';
import Swal from 'sweetalert2'
import { usergroup, page } from '../../../models/users';
import { UserService } from './../../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
import { RSAHelper } from '../../../models/RSAHelper';
@Component({
  selector: 'app-usergroup',
  templateUrl: './usergroup.component.html',
  styleUrls: ['./usergroup.component.css']
})
export class UserGroupComponent implements OnInit {
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  modalRef: BsModalRef;
  selTab: boolean = true;
  @ViewChild('editSettingsTemplate', { static: false }) editTemplate: TemplateRef<any>;
  public userGroup_data: any;
  public page_data: any;
  public editSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public orderData: object;
  public interactionData: object[];
  public usergroupForm: FormGroup;
  public pageArray: FormArray;
  public submitClicked: boolean = false;
  public pageAction: string = 'add';
  public permission: number = 1;
  public title: string = 'Add Role';
  user: any = {};
  isAdmin: boolean = false;
  login_UserID: string;
  noDataImg: any;
  tenantUno: any;
    searchText: string;
    dataSearch: any;
  constructor(public restApi: AdminApiService, public utilityService: UtilityService, private toaster: ToasterService, private router: Router, private spinner: SpinnerVisibilityService, private formBuilder: FormBuilder, private userService: UserService, private modalService: BsModalService, public RASHelper: RSAHelper) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;

    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin) {
      this.router.navigateByUrl('/access-denied');
    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.loadUserGroup();

    this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Dialog' };

    if (this.permission == 1) {
      this.toolbar = ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Search'];
    }
    else
      this.toolbar = ['Search'];

    this.pageSettings = { pageCount: 5 };
    // this.interactionData = DataUtil.distinct(this.data, 'id', true);

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
  }

  // Get usergroup list
  loadUserGroup() {
    this.spinner.show();
    let inpValue = new usergroup();
    inpValue.languageUno = 1033;
    inpValue.condition = 0;
    inpValue.itemUno = 0;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    
    this.restApi.getUserGroups(inpValue)
      .subscribe(data => {
        
        this.userGroup_data = data;
        const mockDataset = [];
        for (let i = 0; i < this.userGroup_data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            usergroupUno: this.userGroup_data[i].usergroupUno,
            usergroupName: this.userGroup_data[i].usergroupName,
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  createFormGroup(data1: any) {
    
    this.usergroupForm = this.formBuilder.group({
      userUno: 2,
      usergroupUno: data1.usergroupUno,
      usergroupName: new FormControl(data1.usergroupName, Validators.required),
      pageArray: this.formBuilder.array([])
    });
  }
  createpageItem(objpage: page): FormGroup {
    
    return this.formBuilder.group({

      pageUno: objpage.pageUno,
      pageName: objpage.pageName,
      showPage: objpage.showPage,
      showAdd: objpage.showAdd,
      showEdit: objpage.showEdit,
      showDelete: objpage.showDelete,
      pageType: objpage.pageType,
      sectionName: objpage.sectionName
    });
  }

  addItem(): void {
    
    this.pageAction = 'add';
    this.title = 'Add Role';
    this.usergroupForm = this.formBuilder.group({
      userUno: this.login_UserID,
      usergroupUno: 0,
      usergroupName: new FormControl(null, Validators.required),
      pageArray: this.formBuilder.array([])
    });
    this.modalRef = this.modalService.show(
      this.editTemplate,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );

    this.spinner.show();
    let inpValue = new page();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getPages(inpValue)
      .subscribe(pagedata => {
        this.page_data = pagedata;
        this.pageArray = this.usergroupForm.get('pageArray') as FormArray;
        for (var i = 0; i < this.page_data.length; i++) {
          
          this.pageArray.push(this.createpageItem(pagedata[i]));
        }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  editItem(args): void {
    
    this.pageAction = 'edit';
    this.title = 'Details of ' + args.usergroupName;
    this.createFormGroup(args);
    this.modalRef = this.modalService.show(
      this.editTemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );

    this.spinner.show();
    let inpValue = new usergroup();
    inpValue.languageUno = 1033;
    inpValue.itemUno = args.usergroupUno;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    inpValue.usergroupUno = args.usergroupUno;
    inpValue.usergroupName = args.usergroupName;
    
    this.restApi.getUserGroupRights(inpValue)
      .subscribe(pagedata => {
        this.page_data = pagedata;
        this.pageArray = this.usergroupForm.get('pageArray') as FormArray;
        for (var i = 0; i < this.page_data.length; i++) {
          
          this.pageArray.push(this.createpageItem(pagedata[i]));
        }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  

  saveRole() {
    this.submitClicked = true;
    if (this.usergroupForm.valid) {
      this.AddEditUserGroup(this.usergroupForm.value);
    }
    else {
      //this.toaster.show('error', 'Check it out!', 'Role is mandatory');
      //Swal.fire('Error', 'Role is mandatory', 'error')
      this.toaster.show('error', 'Error', 'Role is mandatory.');
    }
  }
  AddEditUserGroup(data1: any) {
    
    let objusergroup = new usergroup();
    objusergroup.userUno = this.login_UserID;//this.RASHelper.encryptWithPublicKey(data1.userUno);
    objusergroup.usergroupUno = (this.pageAction == "add") ? 0 : data1.usergroupUno;
    objusergroup.usergroupName = this.utilityService.isStringNull(data1.usergroupName);
    objusergroup.listPage = data1.pageArray;
    objusergroup.condition = (this.pageAction == "add") ? 1 : 2;
    objusergroup.tenantUno = this.tenantUno;
    
    this.restApi.addEditUserGroup(objusergroup)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
         // Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong!');
        }
        else {
          this.toaster.show('success', 'Success', 'Role saved.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Role saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.modalRef.hide();
          this.loadUserGroup();
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  DeleteUserGroup(data1: any) {

    let objUserGroup = new usergroup();

    objUserGroup.userUno = this.login_UserID;//data1[0].userUno;
    objUserGroup.usergroupUno = data1.usergroupUno;
    
    this.restApi.deleteUserGroup(objUserGroup)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong!', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong!');
        }
        else {
          this.toaster.show('success', 'Success', 'Role deleted.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Role deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadUserGroup();
        }

     
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  onChangeTab(val: any) {
    this.spinner.show();

    let temp = this;
    setTimeout(function () {
      temp.spinner.hide();
    }, 700);

    
  }

  public focusIn(target: HTMLElement): void {
    target.parentElement.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement): void {
    target.parentElement.classList.remove('e-input-focus');
  }
 

  get usergroupName(): AbstractControl { return this.usergroupForm.get('usergroupName'); }




  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'usergroupUno', name: 'Role UNO', field: 'usergroupUno', sortable: true, maxWidth:150,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'usergroupUno', 'usergroupUno'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'usergroupName', name: 'Role', field: 'usergroupName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'usergroupName', 'usergroupName'),
          model: Filters.multipleSelect,
        }
      },
    
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', maxWidth: 150,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'edit-row', titleKey: 'edit_row', positionOrder: 62, title: 'Edit',
              
              iconCssClass: 'fa fa-edit fa-lg ', cssClass: 'green-text', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.permission == 1 && data.usergroupName != 'Administrator') 
                  return true;
                else false;
              },
              action: (e, args) => {
                this.editItem(args.dataContext);
              }
            },

            {
              command: 'delete-row', titleKey: 'del_row', positionOrder: 65, title: 'Delete',
              iconCssClass: 'fa fa-trash fa-lg ', cssClass: 'red', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                if (this.permission == 1 && data.usergroupName != 'Administrator')
                  return true;
                else false;
              },
              action: (e, args) => {
                Swal.fire({
                  text: 'Please confirm to delete',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteUserGroup(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                  }
                })
                
              }
            },


          ],
        }
      }

    ]


  }

  
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    if (this.permission == 1 && dataContext.usergroupName != 'Administrator')
      return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
    else
      return '';
  };

  

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.usergroupName && a.usergroupName.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }
    else
      this.dataset = this.dataSearch;
  }

}
